
	import {
		Component,
		Vue,
		Inject,
		Prop,
		Watch
	} from 'vue-property-decorator';
	import Util from '@/lib/util';
	import AbpBase from '@/lib/abpbase';
	import QuestionTpl from '@/store/entities/questiontpl'
	import QuestionTplDet from '@/store/entities/questiontpldet'
	import QuestionTplDetValue from '@/store/entities/questiontpldetvalue'
	import ToggleSwitch from '@/components/ToggleSwitch.vue'
	import videojs from 'video.js';
	import 'viewerjs/dist/viewer.css'
	@Component({
		components: {
			ToggleSwitch
		}
	})
	export default class TestQuestion extends AbpBase {
		qid:number=0;
		updateQuestion: QuestionTpl = new QuestionTpl();
		imagebox: boolean = false;
		visible: boolean = false;
		inputtext:string="";
		isAppHomePrompt:boolean=false;
		detValueList: Array < QuestionTplDetValue >= new Array < QuestionTplDetValue > ();
		detList: Array < QuestionTplDet >= new Array < QuestionTplDet > ();
		isVerifyPrompt:boolean=false;
		isShowError:boolean=false;
		disabled :boolean=false;
		answerBox:boolean = false;
		answerIndex:number=0;
		answerDet:QuestionTplDet=new QuestionTplDet();
		answerTitle:string="";
		imgBox:boolean=false;
		picindex:number=0;	
		picvalueindex:number=0;
		questionDetValue:QuestionTplDetValue=new QuestionTplDetValue();		
		previewImage:string="";		
		previewSuffix:string="";
		visibleImage:boolean=false;
		isEdit:boolean=true;
		
		moveTop(index){
			var that=this;
			var det=that.detValueList[index];
			if(det.sort==1){
				that.$Message.warning(this.L('已经在第一个了'));
			}
			else{										
				//3到1 先把3换到2 再把2换成1
				for(var i=that.detValueList.length-1;i>=0;i--){					
					if(that.detValueList[i].sort<det.sort){
						var sort=that.detValueList[i].sort;//2
						var next=that.detValueList[i+1];						
						that.detValueList[i+1]=that.detValueList[i];
						that.detValueList[i+1].sort=next.sort;
						that.detValueList[i]=next;
						that.detValueList[i].sort=sort;
						console.log(that.detValueList);
						this.$forceUpdate();
					}					
				}				
				this.$forceUpdate();
			}
		}
		moveBottom(index){
			var that=this;
			var det=that.detValueList[index];
			if(det.sort==that.detValueList.length){
				that.$Message.warning(this.L('已经在最后一个了'));
			}
			else{
				//1到3 先把1换到2 再把2换成3
				for(var i=0;i<that.detValueList.length;i++){					
					if(that.detValueList[i].sort>det.sort){
						var sort=that.detValueList[i].sort;//2
						var next=that.detValueList[i-1];						
						that.detValueList[i-1]=that.detValueList[i];
						that.detValueList[i-1].sort=next.sort;
						that.detValueList[i]=next;
						that.detValueList[i].sort=sort;
						console.log(that.detValueList);
						this.$forceUpdate();
					}					
				}				
				this.$forceUpdate();
			}
		}
		movePre(index){
			var that=this;
			var det=that.detValueList[index];			
			if(det.sort==1){
				that.$Message.warning(this.L('已经在第一个了'));
			}
			else{
				var sort=det.sort;
				var preDet=that.detValueList[index-1];
				that.detValueList[index-1]=det;
				that.detValueList[index-1].sort=preDet.sort;
				that.detValueList[index]=preDet;
				that.detValueList[index].sort=sort;				
				this.$forceUpdate();
			}
		}
		moveNext(index){
			var that=this;
			var det=that.detValueList[index];
			if(det.sort==that.detValueList.length){
				that.$Message.warning(this.L('已经在最后一个了'));
			}
			else{
				var sort=det.sort;
				var preDet=that.detValueList[index+1];
				that.detValueList[index+1]=det;
				that.detValueList[index+1].sort=preDet.sort;
				that.detValueList[index]=preDet;
				that.detValueList[index].sort=sort;				
				this.$forceUpdate();
			}
		}
		
		
		setAnswer(index){
			var that = this;
			that.answerIndex=index;
			that.answerDet = that.detList[index];
			that.answerTitle=that.answerDet.name;
			that.answerBox=true;
		}
		saveAnswer(){
			this.detList[this.answerIndex]=this.answerDet;
			this.answerBox=false;
		}
		
		addQuestionItem() {
			var that = this;
			var newItem = new QuestionTplDet();
			newItem.sort = that.detList.length + 1;
			newItem.name = "";
			newItem.questionValueType = 1;
			newItem.isMust = 0;
			newItem.answer = "";
			newItem.answerParse = "";
			newItem.status = "OP";
			newItem.questionTplDetValueList = new Array < QuestionTplDetValue > ();
			that.detList.push(newItem);
			that.$forceUpdate();
		}
		delQuestionItem(index) {
			var that = this;
			(that.detList as Array < Object > ).splice(index, 1);
			for (var i = 0; i < that.detList.length; i++) {
				that.detList[i].sort = (i + 1);
			}
			that.$forceUpdate();
		}
		addQuestionItemValue() {
			var that = this;
			var newItemValue = new QuestionTplDetValue();
			newItemValue.shortName = "";
			newItemValue.name = "";
			newItemValue.file = "";
			newItemValue.status = "OP";
			newItemValue.sort = that.detValueList.length + 1;
			if (newItemValue.sort == 1) {
				newItemValue.shortName = "A";
			} else if (newItemValue.sort == 2) {
				newItemValue.shortName = "B";
			} else if (newItemValue.sort == 3) {
				newItemValue.shortName = "C";
			} else if (newItemValue.sort == 4) {
				newItemValue.shortName = "D";
			}
			that.detValueList.push(newItemValue);
			that.$forceUpdate();
		}
		delQuestionItemValue(valueindex) {
			var that = this;
			that.detValueList.splice(valueindex, 1);
			for (var i = 0; i < that.detValueList.length; i++) {
				that.detValueList[i].sort = (i + 1);
				if ((i + 1) == 1) {
					that.detValueList[i].shortName = "A";
				} else if ((i + 1) == 2) {
					that.detValueList[i].shortName = "B";
				} else if ((i + 1) == 3) {
					that.detValueList[i].shortName = "C";
				} else if ((i + 1) == 4) {
					that.detValueList[i].shortName = "D";
				}
			}
			that.$forceUpdate();
		}
		
		
		// saveFile(){
		// 	var that=this;
		// 	var newItem = that.detList[that.picindex];
		// 	newItem.questionTplDetValueList[that.picvalueindex]=that.questionDetValue;
		// }
		saveFile() {
			var that = this;
			that.detValueList[that.picvalueindex] = that.questionDetValue;
		}
		uploadItemValueFile(valueindex) {
			var that = this;
			that.picvalueindex = valueindex;
			that.questionDetValue = that.detValueList[valueindex];
			that.imgBox = true;
		}
		previewItemValueFile(valueindex) {
			var that = this;	
					debugger
			that.previewImage = that.detValueList[valueindex].file;
			that.previewSuffix=that.detValueList[valueindex].suffix;
			that.visibleImage = true;
		}
		delItemValueFile(valueindex) {
			var that = this;
			that.detValueList[valueindex].file = "";
			that.detValueList[valueindex].suffix = "";
		}
		saveVerify() {
			var that = this;			
			if (that.isAppHomePrompt == true) {
				that.updateQuestion.isAppHomePrompt = true;
			} else if (that.isAppHomePrompt == false) {
				that.updateQuestion.isAppHomePrompt = false;
			}
			if (this.updateQuestion.name == '') {
				that.$Message.warning(this.L('名称不能为空'));
				this.$emit('input', false);
				return
			}
			if (this.updateQuestion.startTime == null || this.updateQuestion.endTime == null) {
				that.$Message.warning(this.L('请选择活动时间'));
				return
			}			
			if (that.detValueList.length == 0) {
				that.$Message.warning(this.L('请添加明细项'));
				return;
			}
			for (var j = 0; j < that.detValueList.length; j++) {
				var eachValue = that.detValueList[j];
				if (eachValue.name == null || eachValue.name.length == 0) {
					that.$Message.warning((this.L('请输入第项名称') as any).replace("{0}", eachValue.sort) );
					return
					break;
				}
			}
			if (that.detList.length == 0) {
				var newItem = new QuestionTplDet();
				newItem.sort = 1;
				newItem.name = that.updateQuestion.name;
				newItem.questionValueType = 1;
				newItem.isMust = 1;
				newItem.answer = "";
				newItem.answerParse = "";
				newItem.status = "OP";
				newItem.questionTplDetValueList = that.detValueList;
				that.detList.push(newItem);
			} else {
				that.detList[0].questionTplDetValueList = that.detValueList;
			}
			that.updateQuestion.questionTplDetList = that.detList;
			
			this.updateQuestion.startTime = Util.changeDate(this.updateQuestion.startTime) as any;
			this.updateQuestion.endTime = Util.changeDate(this.updateQuestion.endTime) as any;
			(this.$refs.queryForm as any).validate(async (valid: boolean) => {
				if (valid) {
					console.log(that.updateQuestion);
					this.$Modal.confirm({
						title: this.L("Tips"),
						content: this.L("确定要保存？"),
						okText: this.L('Yes'),
						cancelText: this.L('No'),
						onOk: async () => {
							that.disabled = true;
							this.$Message.loading({
								content: this.L("保存中"),
								duration: 3
							});
							that.updateQuestion.questionType = 2;											
							that.$store.dispatch({
								type: 'app/createQuestionByApp',
								data: that.updateQuestion
							}).then((res) => {
								that.$Message.destroy();
								that.updateQuestion.id=res;
								//that.$Message.success("保存成功,请等待审核");				
								that.$Modal.success({
									title: this.L("Tips"),
									content: this.L("保存成功,请等待审核")
								});		
							}).catch(res => {
								that.disabled = false;
							});
						}
					});
					}
			})
			
		}
		handleMessage(onoff) {
			this.isAppHomePrompt = onoff;
			// (this.homePageModal as any).isAppHomePrompt = onoff;
		}
		handleMessageVerify(onoff) {
			this.isVerifyPrompt = onoff;
			// (this.homePageModal as any).isAppHomePrompt = onoff;
		}
		handleMessageShow(onoff) {
			this.isShowError = onoff;
			// (this.homePageModal as any).isAppHomePrompt = onoff;
		}
		
		// handleDetValueSuccess
		handleView() {
			this.visible = true;
		}
		handleSuccess(res, file) {
		
		}
		handleRemove() {
			this.imagebox = false;
			this.updateQuestion.pic = '';
		}
		handleUpload(file) {
			const fileExt = file.name.split('.').pop().toLocaleLowerCase()
			if (fileExt === 'jpeg' || fileExt === 'jpg' || fileExt === 'png') {
				this.upload(file);
			} else {
				this.$Notice.warning({
					title: this.L("文件类型错误"),
					desc: this.L('文件不是图片').replace("{0}", file.name )  
				})
		
			}
			return false;
		}
		handleDetValueSuccess(){
			
		}
		handleDetValueRemove() {
			this.questionDetValue.file="";
		}
		handleDetValueView() {
			this.previewImage=this.questionDetValue.file;
			this.previewSuffix = this.questionDetValue.suffix;
			this.visibleImage = true;
		}		
		handleDetValueUpload(file) {
			const fileExt = file.name.split('.').pop().toLocaleLowerCase()
			if (fileExt === 'jpeg' || fileExt === 'jpg' || fileExt === 'png' || fileExt === 'mp4' || fileExt==='mp3') {
				this.uploadDetValue(file,fileExt);
			} else {
				this.$Notice.warning({
					title: this.L("文件类型错误"),
					desc: this.L('文件不是图片').replace("{0}", file.name )  
				})
		
			}
			return false;
		}
		async uploadDetValue(file,fileExt) {
			let that = this;
			var form = new FormData();
			form.append("file", file);
			var res = await this.$store.dispatch({
				type: 'app/uploadImage',
				data: form
			}).then((res) => {				
				that.questionDetValue.file = res;
				that.questionDetValue.suffix=fileExt;
			})
		
		}

		async upload(file) {
			let that = this;
			var form = new FormData();
			form.append("file", file);
			var res = await this.$store.dispatch({
				type: 'app/uploadImage',
				data: form
			}).then((res) => {
				that.updateQuestion.pic = res;
				that.imagebox = true;
			})

		}
		getQuestionTplById() {
			var that = this;
			this.$store.dispatch({
				type: 'app/getQuestionTplById',
				id: this.qid
			}).then((res) => {
				console.log(res);	
				that.updateQuestion = res;
				if(res.status=="OP" && res.isJoin){
					that.isEdit=false;
				}
				that.detList = res.questionTplDetList as Array < QuestionTplDet > ;
				
				for (var i = 0; i < that.detList.length; i++) {
					that.detList[i].isMust = that.detList[i].isMust ? 1 : 0;
				}
				if (that.detList.length > 0) {
					that.detValueList = that.detList[0].questionTplDetValueList;
				}
			})
		}


		async created() {			
			console.log(Util.abp.session.userId);
			if (!Util.abp.session.userId) {				
				var domain = this.$route.query.domain as any;
				if (domain != undefined && domain != null && domain != '') {
					await this.$store.dispatch({
						type: 'app/externalAuthenticate',
						data: {
							"AuthProvider": "IDSDOMAIN",
							"ProviderAccessCode": domain,
							ProviderKey: "",
							Property: ""
						},
					})
					location.reload();
				}
				var userId = this.$route.query.userid as any;
				if (userId != undefined && userId != null && userId != '') {
					await this.$store.dispatch({
						type: 'app/externalAuthenticate',
						data: {
							"AuthProvider": "IDSID",
							"ProviderAccessCode": userId,
							ProviderKey: userId,
							Property: ""
						},
					})
					location.reload();
				}
			}
			if (this.$route.query.qid && (this.$route.query.qid as any) > 0) {
				this.qid = this.$route.query.qid as any;
				
				this.getQuestionTplById();				
			}
			else{
				this.updateQuestion = new QuestionTpl();
				this.updateQuestion.point = 0;
				this.updateQuestion.lotteryCount = 0;
				this.updateQuestion.voteCount = 0;
				this.updateQuestion.voteDayCount = 0;
				this.updateQuestion.name = "";
				this.updateQuestion.id = 0;
				this.isAppHomePrompt = (this.updateQuestion.isAppHomePrompt == null || !this.updateQuestion.isAppHomePrompt) ? false :
					true;				
			}
		}
		rules = {
			name: [{
				required: true,
				message:  this.L('名称不能为空'),
				trigger: 'blur'
			}],
			desc: [{
				required: true,
				message: this.L('描述不能为空'),
				trigger: 'blur'
			}],
			startTime: [{
				required: true,
				message: this.L('开始时间不能为空'),

			}],
			endTime: [{
				required: true,
				message: this.L('结束时间不能为空'),

			}],
		}
	}
